export enum CreditRatingFields {
    poor = 'poor',
    fair = 'fair',
    good = 'good',
    excellent = 'excellent'
}

export const CreditRatingTitles = new Map<string, string>([
    [CreditRatingFields.poor, 'Poor'],
    [CreditRatingFields.fair, 'Fair'],
    [CreditRatingFields.good, 'Good'],
    [CreditRatingFields.excellent, 'Excellent'],
]);
    
export const CreditRatingApr = new Map<string, number>([
    [CreditRatingFields.poor, 14.9],
    [CreditRatingFields.fair, 12.9],
    [CreditRatingFields.good, 10.9],
    [CreditRatingFields.excellent, 9.9],
]);
  